import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlighter',
})
export class HighlighterPipe implements PipeTransform {
  transform(text: string, search: string | null): string {
    if (!search) {
      return text; // ✅ Avoid errors if search is empty
    }

    const pattern = search
      .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') // Escape regex
      .split(' ')
      .filter((t: any) => t.length > 0)
      .join('|');

    const regex = new RegExp(pattern, 'gi');
    return text.replace(regex, (match) => `<strong>${match}</strong>`);
  }
}
